"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const PropTypes = tslib_1.__importStar(require("prop-types"));
const React = tslib_1.__importStar(require("react"));
const redux_form_1 = require("../DatePickers/redux-form");
const redux_form_2 = tslib_1.__importDefault(require("../Checkbox/redux-form"));
const redux_form_3 = tslib_1.__importDefault(require("../ColorControl/redux-form"));
const redux_form_4 = tslib_1.__importDefault(require("../ColorPicker/redux-form"));
const index_1 = tslib_1.__importDefault(require("./index"));
const redux_form_5 = tslib_1.__importDefault(require("../ImageControl/redux-form"));
const redux_form_6 = tslib_1.__importDefault(require("../Input/redux-form"));
const redux_form_7 = tslib_1.__importDefault(require("../Radio/redux-form"));
const redux_form_8 = tslib_1.__importDefault(require("../Select/redux-form"));
const redux_form_9 = tslib_1.__importDefault(require("../SmarttagsControl/SmarttagControl/redux-form"));
const redux_form_10 = tslib_1.__importDefault(require("../Switch/redux-form"));
const redux_form_11 = tslib_1.__importDefault(require("../Textarea/redux-form"));
const redux_form_12 = tslib_1.__importDefault(require("../TheSelect/redux-form"));
const redux_form_13 = tslib_1.__importDefault(require("../TheSelectSimple/redux-form"));
const DEFAULT_COMPONENT_MAP_REDUX = {
    checkbox: redux_form_2.default,
    color: redux_form_4.default,
    colorInput: redux_form_3.default,
    date: redux_form_1.DatePicker,
    dateTime: redux_form_1.DateTimePicker,
    default: redux_form_6.default,
    image: redux_form_5.default,
    radio: redux_form_7.default,
    select: redux_form_8.default,
    smarttag: redux_form_9.default,
    switch: redux_form_10.default,
    textarea: redux_form_11.default,
    theselect: redux_form_12.default,
    theselectsimple: redux_form_13.default,
    time: redux_form_1.TimePicker,
};
const FormFieldRedux = (props) => {
    const { meta: { touched, error }, componentMap = DEFAULT_COMPONENT_MAP_REDUX, } = props;
    return (React.createElement(index_1.default, Object.assign({}, props, { componentMap: componentMap, error: touched && error ? error : null })));
};
FormFieldRedux.propTypes = {
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }).isRequired,
    componentMap: PropTypes.shape({}),
};
FormFieldRedux.defaultProps = {
    componentMap: DEFAULT_COMPONENT_MAP_REDUX,
};
exports.default = FormFieldRedux;
